export const TRACKING_CONTEXTS = {
  EDIT_CLIENT: 'edit-client-info',
  EDIT_BILLING: 'edit-billing-info',
  EDIT_BTOB: 'edit-btob',
};
